import { ReactElement, useMemo } from 'react';
import BaseCrrTimeOfDayPlot, { DataFieldConfig } from './BaseCrrTimeOfDayPlot';

interface CrrDeltaTimeOfDayPlotProps {
  session: any;
  equipmentCatalog: any;
  pressureUnit: 'Bar' | 'PSI';
  deltaAverage: 'Constant' | 'Moving';
  height?: number;
}

/**
 * Crr Deltas vs Time of Day plot showing delta Crr values
 * Supports both Constant and Moving average modes
 */
export default function CrrDeltaTimeOfDayPlot({
  session,
  equipmentCatalog,
  pressureUnit,
  deltaAverage,
  height = 400,
}: CrrDeltaTimeOfDayPlotProps): ReactElement {
  // Configure data fields based on deltaAverage mode
  const dataFieldConfig: DataFieldConfig = useMemo(() => {
    if (deltaAverage === 'Moving') {
      return {
        traverseSource: 'deltas_traverse_rolling',
        traverseField: 'Crr_xG5',
        averageSource: 'deltas_rolling',
        averageField: 'Crr_xG5',
      };
    }
    return {
      traverseSource: 'deltas_traverse',
      traverseField: 'Crr_xG5',
      averageSource: 'deltas',
      averageField: 'Crr_xG5',
    };
  }, [deltaAverage]);

  return (
    <BaseCrrTimeOfDayPlot
      session={session}
      equipmentCatalog={equipmentCatalog}
      pressureUnit={pressureUnit}
      height={height}
      title={`Crr Deltas vs Time of Day (${deltaAverage} Average)`}
      yAxisTitle="Crr Delta<br>(Temperature Adjusted)"
      hoverLabel="Crr Delta Average"
      noDataMessage="No Crr delta time data available"
      traceSuffix="avg_delta"
      dataFieldConfig={dataFieldConfig}
    />
  );
}
